<div class="view-info eip-mb-20">
    <p class="view-label">{{field.label}}</p>
    <p class="view-data">{{labelValue}}</p>
</div>